<div *ngIf="type==='instance'">
  <ion-list >
    <ion-item button [detail]="false" (click)="onEdit()">
      <span style="margin-left: 20px;"><i class="fa-regular fa-pen-to-square"></i> Edit project</span>
    </ion-item>
    <ion-item button [detail]="false" lines="none"  (click)="onDelete()">
      <span style="margin-left: 20px;"><i class="fa-regular fa-trash-can"></i> Delete project</span>
    </ion-item>
  </ion-list>
</div>

<div *ngIf="type==='server'">
  <ion-list >
    <ion-item button [detail]="false" (click)="onEdit()">
      <span style="margin-left: 20px;"><i class="fa-regular fa-pen-to-square"></i> Edit server</span>
    </ion-item>
    <ion-item button [detail]="false" lines="none"  (click)="onDelete()">
      <span style="margin-left: 20px;"><i class="fa-regular fa-trash-can"></i> Delete server</span>
    </ion-item>
  </ion-list>
</div>
